import React, {h} from 'preact';

export default function SpinnerStep() {
    return <i className="fa fa-spinner fa-pulse" style="color: #aaa; font-size: 70px; margin: 200px auto 0; position: relative; text-align: center; width: 100%"/>;
}
